import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import Template from "./Template";

const Greetings = props => (
  <Template
    title="Szanowni Państwo!"
    navigationRight={[
      <button
        onClick={() => {
          props.history.push("/instrukcja");
          window.scrollTo(0, 0);
        }}
        className="button is-danger is-medium"
      >
        Dalej
      </button>
    ]}
  >
    <h3>Serdecznie witamy na naszej stronie internetowej.</h3>
    <p>
      Bardzo dziękujemy za zainteresowanie jakie okazali Państwo naszej firmie i
      jednocześnie chcielibyśmy zaprosić do wzięcia udziału w testach
      sensorycznych naszych produktów.
    </p>
    <p>
      Jednakże, abyśmy mogli zapraszać Państwa na testowanie produktów, musimy
      zadać kilka pytań. W tym celu przygotowaliśmy kwestionariusz wstępny.
      Ankietę można wypełnić samodzielnie przez internet lub bezpośrednio w
      Pracowni Analizy Sensorycznej znajdującej się w Gdańsku Oliwie, przy ul.
      Adm. Dickmana 14/15, gdzie pracownik firmy Dr. Oetker pomoże Państwu w jej
      wypełnieniu.
    </p>
    <p>
      <strong>
        Zanim przystąpią Państwo do wypełniania kwestionariusza prosimy zapoznać
        się z kryteriami jakie należy spełniać, aby móc uczestniczyć w testach
        sensorycznych.
      </strong>
    </p>
    <p>Jeśli:</p>
    <ul>
      <li>
        mieszkają Państwo w Trójmieście lub okolicach i mają skończone 18 lat;
      </li>
      <li>
        są Państwo gotowi odwiedzać nas w siedzibie Pracowni Analizy
        Sensorycznej;
      </li>
      <li>posługują się Państwo językiem polskim w mowie i piśmie;</li>
      <li>cechuje Państwa ciekawość i otwartość wobec nowych produktów;</li>
      <li>
        będziemy mogli się z Państwem kontaktować pod podanym numerem telefonu;
      </li>
    </ul>
    <p>to prosimy kontynuować.</p>
  </Template>
);
Greetings.propTypes = {
  history: PropTypes.shape().isRequired
};
export default withRouter(Greetings);



// WEBPACK FOOTER //
// ./src/components/pages/Greetings.js